export default __webpack_public_path__ + "static/media/badge_icon_2.225d2e03.svg";